import { render, staticRenderFns } from "./ModalDirectorySkillsPriorities.vue?vue&type=template&id=664960d3&lang=pug&"
import script from "./ModalDirectorySkillsPriorities.vue?vue&type=script&lang=js&"
export * from "./ModalDirectorySkillsPriorities.vue?vue&type=script&lang=js&"
import style0 from "./ModalDirectorySkillsPriorities.vue?vue&type=style&index=0&id=664960d3&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports